/* eslint-disable prettier/prettier */
export const FileTableHeader = ({ allSelected, onToggleAll }: { allSelected: boolean, onToggleAll: () => void }) => (
  <div className="flex items-center px-4 py-3 font-semibold border text-md sm:w-[90%] bg-gray-50 text-muted-foreground">
    <div className="w-[5%]">
      <input
        type="checkbox"
        checked={allSelected}
        onChange={onToggleAll}
        className="accent-primary"
      />
    </div>
    <div className="w-[55%]">Name</div>
    <div className="w-[20%]">Date</div>
    <div className="w-[15%]">Size</div>
    <div className="w-[5%]"></div>
  </div>
);
